<main class="c-main" role="main">
    <div class="c-page-access">
        <div class="container u-pb30">
            <div class="row mobile u-pt40 u-pb10">
                <div class="col-md-8">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a [routerLink]="['']" style="color: black;"> {{'verification.home'|translate}} &nbsp;</a></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: black;"> - <a style="color: black;" [routerLink]="['/external-accesses']">{{'verification.third-verification'|translate}} &nbsp;</a></li>
                            <li class="breadcrumb-item active" aria-current="page" style="color: black;"> - <span style="color: black;">{{'verification.authorized'|translate}}</span></li>
                        </ol>
                    </nav>
                    <h2 class="o-title js-txt3">{{'verification.authorized'|translate}}</h2>
                </div>
                <div class="col-md-12" *ngIf="person">

                    <div class="col-md-4" style="padding-left: 0px">
                        <p><strong>{{'verification.name' |translate}}:&nbsp; </strong> {{person.firstName}}&nbsp; {{person.lastName}}</p>
                        <p><strong>{{title}}:&nbsp; </strong> {{person.nationalId}} {{person.passportNumber}}</p>
                        <p><strong>{{'verification.type'|translate}}:&nbsp; </strong> {{person.employeeType}}</p>
                    </div>
                    <div class="col-md-4" style="padding-left: 0px">
                        <p><strong>{{'verification.mail-bhp'|translate}}:&nbsp; </strong> {{person.email}}</p>
                        <p *ngIf="typePeopleContractor"><strong>{{'verification.mail-vendor'|translate}}:&nbsp; </strong> {{person.companyEmail}}</p>
                        <p *ngIf="typePeopleContractor"><strong>{{'verification.business'|translate}}:&nbsp; </strong> {{person.companyName}}</p>
                        <p *ngIf="!typePeopleContractor"><strong>{{'verification.site'|translate}}:&nbsp; </strong> {{person.companyName}}</p>
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="accesses">
                <div class="col-lg-12" *ngIf="accesses.length===0">
                    <div class="u-pt20">
                        <div class="c-card c-card--success">
                            <div class="c-card__title">{{'MyAuthorizedAccessPortal.notAuthorized' | translate}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" *ngFor="let accesse of accesses">
                    <!--NGFOR-->
                    <div class="">
                        <div class="c-card c-card--success">
                            <div class="c-card__title">{{accesse.siteName | titlecase}}<span class="js-txt16"> {{'MyAuthorizedAccessPortal.titleTable' | translate}}</span></div>
                            <div class="row">
                                <div class="col-md-4">
                                    <p class="table__request"><strong class="js-txt6">{{'MyAuthorizedAccessPortal.labelRequestNumber' | translate}}: </strong> {{accesse.accessDetail.requestNumber}}</p>
                                    <!-- <p><strong class="js-txt7">{{'MyAuthorizedAccessPortal.labelRequestor' | translate}}: </strong> {{accesse.requestor}}</p> -->
                                </div>
                                <div class="col-md-4">
                                    <p> <strong class="js-txt9">{{'MyAuthorizedAccessPortal.labelZone' | translate}}: </strong> {{accesse.zoneName}} </p>
                                    <p *ngIf="accesse.subZoneName != ''"> <strong class="js-txt9">{{'MyAuthorizedAccessPortal.labelSubzone' | translate}}: </strong> {{accesse.subZoneName}} </p>
                                </div>
                                <div class="col-md-4">
                                    <div class="c-card__from"><i class="icon icon-calendar"></i>
                                        <p> <strong class="js-txt10">{{'MyAuthorizedAccessPortal.labelFrom' | translate}} </strong> {{accesse.accessDetail.periodFrom | date: 'dd/MM/yyyy'}}</p>
                                    </div>
                                    <div class="c-card__to"><i class="icon icon-calendar"></i>
                                        <p> <strong class="js-txt11">{{'MyAuthorizedAccessPortal.labelTo' | translate}} </strong> {{accesse.accessDetail.periodTo | date: 'dd/MM/yyyy'}}</p>
                                    </div>
                                    <!-- <p *ngIf="accesse.status===1" style="color: red"><i class="icon icon-warning"></i> <strong> {{'verification.manage-access'|translate}}</strong>
                   </p> -->
                                </div>
                                <div class="col-md-12 col-xs-12">
                                    <h6 *ngIf="accesse.status===0" style="padding-top: 10px;">
                                        <hr>
                                        <p><i class="icon icon-warning" style="background-color: transparent;color: #767372;"></i> {{'verification.bring'|translate}}
                                        </p>
                                    </h6>
                                    <h6 *ngIf="accesse.status===1" style="padding-top: 10px;">
                                        <hr style="color: seagreen !important;">
                                        <p style="color: red"><i class="icon icon-warning" style="background-color: transparent;color: #767372;"></i> {{'verification.app-approved'|translate}}
                                            <a *ngIf="displayQualification" style="display:none !important;padding-left:25px; color: rgb(246, 123, 0); cursor:pointer;" (click)="seeQualifications(accesse.qualifications)"> 
                          {{'MyAuthorizedAccessPortal.labelStatus' | translate}}
                        </a>
                                        </p>
                                    </h6>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 u-pt20">
                    <!-- <button class="btn btn--primary" style="font-size: 16px;line-height: 23px;width: 82%;"  [attr.disabled]="accesses.length===0 ? true: null"
            [routerLink]="['/external-accesses/details/', person.email]" >Verificar Calificaciones de Acceso</button>  -->
                    <button class="btn btn--primary" style="font-size: 16px;line-height: 23px;width: 82%;" [routerLink]="['/external-accesses/details/',emailRut]">{{'verification.check-access'|translate}}</button>
                </div>
            </div>
        </div>
    </div>
</main>